<template>
  <b-row id="table-diagnostic-log">
    <b-col cols="12">
      <b-table
        :items="diagnostics"
        :fields="fields"
        :busy="isLoaging"
        class="col-12 mt-2 table-views"
        show-empty
      >
        <template #empty>
          <div class="text-center my-2">
            <h2>No tienes diagnósticos registrados</h2>
          </div>
        </template>
        <template #cell(options)="row">
          <button
            class="button-table-employee"
            :id="`tooltip-button-qualification-${row.item.id}`"
            @click.prevent="qualification(row.item)"
          >
            <img
              class="centerImg1 resaltar"
              :src="require('@/assets/images/icons/editlist.svg')"
            />
          </button>
          <button
            class="button-table-employee"
            :id="`tooltip-button-ver-${row.item?.id}`"
            @click.prevent="findItem(row.item?.id)"
          >
            <img
              class="centerImg1 resaltar"
              :src="require('@/assets/images/icons/eye-line.svg')"
            />
          </button>

          <button
            class="button-table-employee"
            @click.prevent="editItem(row.item?.id)"
            :id="`tooltip-button-edit-${row.item?.id}`"
          >
            <span class="icon-pencil centerImg1 resaltar"> </span>
          </button>

          <button
            class="button-table-employee"
            :id="`tooltip-button-delete-${row.item.id}`"
            @click.prevent="deleteItem(row.item.id)"
          >
            <img
              class="centerImg1 resaltar icondelete"
              :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
            />
          </button>

          <b-tooltip
            :target="`tooltip-button-qualification-${row.item.id}`"
            placement="top"
            custom-class="custom-tooltip-ht"
          >
            Calficaciones
          </b-tooltip>

          <b-tooltip
            :target="`tooltip-button-ver-${row.item.id}`"
            placement="top"
            custom-class="custom-tooltip-ht"
          >
            Ver Diagnóstico
          </b-tooltip>
          <b-tooltip
            :target="`tooltip-button-edit-${row.item.id}`"
            placement="top"
            custom-class="custom-tooltip-ht"
          >
            Editar Diagnóstico
          </b-tooltip>
          <b-tooltip
            :target="`tooltip-button-delete-${row.item.id}`"
            placement="top"
            custom-class="custom-tooltip-ht"
          >
            Eliminar Diagnóstico
          </b-tooltip>
        </template>
        <template #table-busy>
          <div class="text-center my-2 mb-3">
            <overlay-button></overlay-button>
          </div>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>
<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
</style>
<!-- <style lang="scss" src="./styles.scss" /> -->
